/** Open the left admin drawer only when this beat is actually about that menu. */
export function stepWantsAdminSidebar(step) {
  if (!step || step.closeSidebar) return false;
  return (
    String(step.tourId || "").startsWith("admin-nav") ||
    String(step.navTourId || "").startsWith("admin-nav")
  );
}
